import React from 'react';
import { Menu } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const ChooseLanguage = ({ language, updateLanguage }) => {
  const languageOptions = [
    { value: 'en', text: 'En' },
    { value: 'fr', text: 'Fr' }
  ];

  const handleLanguageChange = (e, data) => {
    updateLanguage(data.value);
  };

  return (
    <Menu inverted borderless className="languages">
      <Menu.Menu>
        {languageOptions.map(lang => (
          <Menu.Item
            key={lang.value}
            value={lang.value}
            active={language === lang.value}
            onClick={handleLanguageChange}
            content={lang.text}
          />
        ))}
      </Menu.Menu>
    </Menu>
  );
};

ChooseLanguage.propTypes = {
  language: PropTypes.string.isRequired,
  updateLanguage: PropTypes.func.isRequired
};

export default ChooseLanguage;
